import { UserDetailsService } from "./../../login/services/UserDetails.service";
import { Component, DestroyRef, inject, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { UpdateNoticeService } from "./../service/updatenotice.service";
import { UpdateNoticeSummaryDTO } from "./../model/UpdateNoticeSummaryDTO";
import { ConfigService } from "../../utils/config.service";
import * as mock from "../../../assets/update-notice-list.json";
import { AisProduct } from "src/app/shared/enums/AisProducts";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatTabChangeEvent } from "@angular/material/tabs";

@Component({
  selector: "app-updatenotice-list",
  templateUrl: "./updatenotice-list.component.html",
  styleUrls: ["./updatenotice-list.component.scss"],
})
export class UpdatenoticeListComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);

  isDp: boolean = ConfigService.settings.isDataProvider;

  isUnReader: boolean = ConfigService.settings.isUnReader;

  isAis: boolean = ConfigService.settings.isAis;

  public userName: string;

  public groupName: string;

  updatenoticelist: UpdateNoticeSummaryDTO[] = [];

  closedUnList: UpdateNoticeSummaryDTO[] = [];

  updatenotice: UpdateNoticeSummaryDTO;

  displayedColumns = ["status", "aisProduct", "name", "effectiveDate", "cancelDate", "temporality"];
  //displayedColumns = ['Title', 'Cancel date', 'Effective date', 'Temporality'];
  updatenoticelist_dataSource = new MatTableDataSource<UpdateNoticeSummaryDTO>(this.updatenoticelist);

  closed_updatenoticelist_dataSource = new MatTableDataSource<UpdateNoticeSummaryDTO>(this.closedUnList);

  aisProductLookup = {
    [AisProduct.AMDT]: "AIP Amendment",
    [AisProduct.SUP]: "AIP Supplement",
    [AisProduct.NOTAM]: "NOTAM",
    [AisProduct.AIC]: "AIC",
  };

  //sorting
  @ViewChild("sortOpen") sortOpen: MatSort;
  @ViewChild("sortClosed") sortClosed: MatSort;
  //pagination
  @ViewChild(MatPaginator) paginator: MatPaginator;

  /**
   * Set the sort after the view init since this component will
   * be able to query its view for the initialized sort.
   */
  ngAfterViewInit() {
    this.updatenoticelist_dataSource.sort = this.sortOpen;
    this.updatenoticelist_dataSource.paginator = this.paginator;
  }

  //filter rows
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.updatenoticelist_dataSource.filter = filterValue;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private updatenoticeService: UpdateNoticeService,
    private userDetailsService: UserDetailsService,
  ) {}
  ngOnInit() {
    console.log(this.isDp, "### IS DP");
    this.getUpdateNoticeList();
    this.getClosedUpdateNoticeList();
    if (this.isDp) {
      this.getOrganization();
    }
  }

  getUpdateNoticeList(): void {
    // only check for DP
    // if its DP this.updatenoticeService.getUpdateNoticeListByOriginator()
    // else getUpdateNoticeList()

    // const service$ = this.isDp
    //   ? this.updatenoticeService.getUpdateNoticeListByOriginator()
    //   : this.updatenoticeService.getUpdateNoticeList();

    /**
     * --- Temporary ---
     * Use getUpdateNoticeList method, since this method already filters the UN by their assigned originator. If user having ais-admin role, they can see all UNs.
     */
    this.updatenoticeService
      .getUpdateNoticeList()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((updatenoticelist) => {
        const parsed = updatenoticelist.map((data) => {
          return UpdateNoticeSummaryDTO.parse({ ...data });
        });
        this.updatenoticelist_dataSource.data = parsed;
      });
  }

  getClosedUpdateNoticeList(): void {
    if (this.isDp && this.isUnReader) {
      // ais-admin role can also retrieve closed
      this.updatenoticeService
        .getClosedUpdateNoticeList()
        .pipe(takeUntilDestroyed(this._destroyRef))
        .subscribe((closedUnList) => {
          const parsed = closedUnList.map((data) => {
            return UpdateNoticeSummaryDTO.parse({ ...data });
          });
          console.log(parsed, "### CLOSED UN LIST");
          this.closed_updatenoticelist_dataSource.data = parsed;
        });
    }
  }

  getOrganization(): void {
    this.updatenoticeService.getOrganization().subscribe((groupName) => (this.groupName = groupName));
  }

  onTabChange(event: MatTabChangeEvent) {
    if (event.index === 0) {
      this.updatenoticelist_dataSource.sort = this.sortOpen;
      this.updatenoticelist_dataSource.paginator = this.paginator;
    } else {
      this.closed_updatenoticelist_dataSource.sort = this.sortClosed;
      this.closed_updatenoticelist_dataSource.paginator = this.paginator;
    }
  }
}
